export function definedAttributesOf(source) {
    const result = {};
    if (!source) {
        return result;
    }
    for (const key of Object.keys(source)) {
        const value = source[key];
        if (value !== undefined) {
            result[key] = value;
        }
    }
    return result;
}
export default definedAttributesOf;
